import React from "react";
import { Link } from "react-router";

const BrandLogoOrName = ({ brand }) => {
  const { name, logo, key } = brand;

  var output = <b>{name}</b>;
  if (logo) {
    output = <img className="brand-logo" src={process.env.PUBLIC_URL + "/img/" + logo} alt={name}/>;
  }

  return(
    <Link to={"/car-seats/" + key} >
      {output}
    </Link>
  );
};

BrandLogoOrName.propTypes = {
  brand: React.PropTypes.object.isRequired
};

export default BrandLogoOrName;



/** WEBPACK FOOTER **
 ** ./src/components/AvailableSizes/CarSeatsContainer/Brands/BrandLogoOrName.js
 **/